import { ArrowUpRight } from "lucide-react";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Projects", href: "#projects" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/10 pt-20 md:pt-28 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16">
          <div className="md:col-span-6">
            <a href="#top" className="inline-flex items-center">
              <img
                src="/dmab-logo-dark.png"
                alt="DMAB Solutions"
                className="h-20 w-auto"
              />
            </a>
            <p className="mt-6 max-w-sm text-[#94A3B8] font-light leading-relaxed">
              ACN: 700 562 910
              <br />
              ABN: 56 700 562 910
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-[#94A3B8]">
              Navigate
            </div>
            <ul className="mt-5 space-y-3">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="inline-flex items-center gap-1 text-white/80 hover:text-[#00F0FF] transition-colors"
                  >
                    {l.label}
                    <ArrowUpRight size={14} />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-[#94A3B8]">
              Reach us
            </div>
            <ul className="mt-5 space-y-3 text-white/80">
              <li>
                <a
                  href="mailto:admin@dmabsolutions.com.au"
                  className="hover:text-[#00F0FF] transition-colors break-all"
                >
                  admin@dmabsolutions.com.au
                </a>
              </li>
              <li>
                <a href="tel:0494523118" className="hover:text-[#00F0FF] transition-colors">
                  0494 523 118
                </a>
              </li>
              <li className="text-[#94A3B8] text-sm leading-snug">
                21 Crombie Avenue,<br />Bundall QLD 4217
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 border-t border-white/10 py-8">
          <p className="text-sm text-[#94A3B8]">
            © {year} DMAB Solutions. All rights reserved.
          </p>
          <p className="text-sm text-[#94A3B8]">Gold Coast, Australia</p>
        </div>
      </div>

      {/* Giant wordmark */}
      <div className="px-4 pb-6 select-none pointer-events-none">
        <div className="font-display font-black tracking-tighter text-white/5 text-[19vw] leading-[0.75] text-center whitespace-nowrap">
          DMAB
        </div>
      </div>
    </footer>
  );
}
